export default "### How will this ever work? If I live in a house, I want to be there for the long term!\n";